import type { Editor } from "@tiptap/react";
import { useEffect } from "react";

import type { NotionEditorProps } from "../types";

export const useEditorContentSync = ({
  editor,
  initialContent,
  contentMode,
}: {
  contentMode: NonNullable<NotionEditorProps["contentMode"]>;
  editor: Editor | null;
  initialContent: NotionEditorProps["initialContent"];
}) => {
  useEffect(() => {
    if (!editor || initialContent === undefined) {
      return;
    }

    if (contentMode === "markdown" && typeof initialContent === "string") {
      if (editor.getMarkdown() === initialContent) {
        return;
      }
    } else {
      const currentContent = JSON.stringify(editor.getJSON());
      const nextContent = JSON.stringify(initialContent);

      if (currentContent === nextContent) {
        return;
      }
    }

    editor.commands.setContent(initialContent, {
      contentType: contentMode === "markdown" ? "markdown" : "json",
      emitUpdate: false,
    });
  }, [contentMode, editor, initialContent]);
};
